import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=272e631e&scoped=true&"
import script from "./Package.vue?vue&type=script&lang=js&"
export * from "./Package.vue?vue&type=script&lang=js&"
import style0 from "./Package.vue?vue&type=style&index=0&id=272e631e&scoped=true&lang=css&"
import style1 from "./Package.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272e631e",
  null
  
)

component.options.__file = "Package.vue"
export default component.exports